// extracted by mini-css-extract-plugin
export default {"errorLayout":"styles_errorLayout__11q5l","errorTitle":"styles_errorTitle__k2H3T","errorDescription":"styles_errorDescription__UIqO1","buttonsGap":"styles_buttonsGap__rCRsG"};